import AuthProvider from '@bootstrap/auth/context';
import QueryProvider from '@bootstrap/providers/query/provider';

import type { TPermissions } from '@modules/core/types';

import { UnauthorizedModal } from '@shared/components/molecules/unauthorized-modal';
import { AppVersionCheck } from '@shared/components/organisms/app-version';

import ProvidersErrorBoundary from './error-boundary/index';
import { AppRouterProvider } from './router/provider';
import { SideSheetProvider } from './side-sheet/provider';
import ThemeProvider from './theme/provider';
import APToastProvider from './toast/provider';

interface AppProvidersProps {
  children?: React.ReactNode;
  userPermissions?: TPermissions;
}

export const AppProviders: React.FC<AppProvidersProps> = ({
  children,
  userPermissions = { roles: [] },
}) => {
  return (
    <ProvidersErrorBoundary>
      <QueryProvider>
        <APToastProvider>
          <AuthProvider>
            <ThemeProvider>
              <SideSheetProvider>
                <AppRouterProvider userPermissions={userPermissions}>{children}</AppRouterProvider>
                <UnauthorizedModal />
                <AppVersionCheck />
              </SideSheetProvider>
            </ThemeProvider>
          </AuthProvider>
        </APToastProvider>
      </QueryProvider>
    </ProvidersErrorBoundary>
  );
};
